
import { Prop, Vue } from 'vue-property-decorator';

export default abstract class RHBaseClass extends Vue {
    @Prop({}) protected id!: string;
}
